<template>
  <div class="modals">
    <!-- Overlay -->
    <transition name="fade">
      <div class="modals-overlay" v-show="modalsShow !== null"></div>
    </transition>

    <!-- Desktop için slide-fade, mobil için slide-up -->
    <transition :name="isMobile ? 'slide-up' : 'slide-fade'" mode="out-in">
      <div
        class="modals-holder"
        v-if="modalsShow !== null"
        @click="modalsCloseButton"
        :class="{ 'is-mobile': isMobile }"
      >
        <div class="holder-body">
          <div class="body-modal" :class="{ 'bottom-sheet': isMobile }">
            <!-- Close button (bazı modallar hariç) -->
            <button
              v-if="['DuelsGame', 'BattlesSelect', 'Box'].includes(modalsShow) !== true"
              @click="modalsSetShow(null)"
              class="button-close"
            >
              <div class="button-inner">
                <IconClose />
              </div>
            </button>

            <!-- Dinamik modal -->
            <component :is="'Modal' + modalsShow" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconClose from "@/components/icons/IconClose";

/* Tüm modal importlarını koruyorum */
import ModalCaptcha from "@/components/modals/ModalCaptcha";
import ModalLogin from "@/components/modals/ModalLogin";
import ModalLink from "@/components/modals/ModalLink";
import ModalLinkRoblox from "@/components/modals/ModalLinkRoblox";
import ModalReset from "@/components/modals/ModalReset";
import ModalClaim from "@/components/modals/ModalClaim";
import ModalChatRules from "@/components/modals/ModalChatRules";
import ModalChatUser from "@/components/modals/ModalChatUser";
import ModalRemove from "@/components/modals/ModalRemove";
import ModalMute from "@/components/modals/ModalMute";
import ModalBan from "@/components/modals/ModalBan";
import ModalCashier from "@/components/modals/ModalCashier";
import ModalRobux from "@/components/modals/ModalRobux";
import ModalCredit from "@/components/modals/ModalCredit";
import ModalPapara from "@/components/modals/ModalPapara";
import ModalPayfix from "@/components/modals/ModalPayfix";
import ModalPix from "@/components/modals/ModalPix";
import DepositCryptoModal from "@/components/modals/DepositCryptoModal";
import DepositOptionsModal from "@/components/modals/DepositOptionsModal";
import ModalCrypto from "@/components/modals/ModalCrypto";
import ModalGift from "@/components/modals/ModalGift";
import ModalProceed from "@/components/modals/ModalProceed";
import ModalTwoStep from "@/components/modals/ModalTwoStep";
import ModalVault from "@/components/modals/ModalVault";
import ModalTip from "@/components/modals/ModalTip";
import ModalFair from "@/components/modals/ModalFair";
import ModalFairSeed from "@/components/modals/ModalFairSeed";
import ModalFairGame from "@/components/modals/ModalFairGame";
import ModalFaq from "@/components/modals/ModalFaq";
import ModalTerms from "@/components/modals/ModalTerms";
import ModalPrivacy from "@/components/modals/ModalPrivacy";
import ModalBlackjackRules from "@/components/modals/ModalBlackjackRules";
import ModalDuelsGame from "@/components/modals/ModalDuelsGame";
import ModalBattlesModes from "@/components/modals/ModalBattlesModes";
import ModalBattlesSelect from "@/components/modals/ModalBattlesSelect";
import ModalBox from "@/components/modals/ModalBox";
import ModalAdminConfirm from "@/components/modals/ModalAdminConfirm";
import ModalAdminUser from "@/components/modals/ModalAdminUser";
import ModalAdminAffiliate from "@/components/modals/ModalAdminAffiliate";
import ModalAdminCrypto from "@/components/modals/ModalAdminCrypto";
import ModalSpin from "@/components/modals/ModalSpin";
import ModalLisance from "@/components/modals/ModalLisance";
import ModalNotifications from "@/components/modals/ModalNotifications";
import ModalSocialComplete from "@/components/modals/ModalSocialComplete";

export default {
  components: {
    IconClose,
    DepositCryptoModal,
    DepositOptionsModal,
    ModalSpin,
    ModalCaptcha,
    ModalLogin,
    ModalLink,
    ModalLinkRoblox,
    ModalReset,
    ModalClaim,
    ModalChatRules,
    ModalChatUser,
    ModalRemove,
    ModalMute,
    ModalBan,
    ModalVault,
    ModalCashier,
    ModalRobux,
    ModalCredit,
    ModalPayfix,
    ModalPapara,
    ModalPix,
    ModalLisance,
    ModalCrypto,
    ModalGift,
    ModalProceed,
    ModalTwoStep,
    ModalTip,
    ModalFair,
    ModalFairSeed,
    ModalFairGame,
    ModalFaq,
    ModalTerms,
    ModalPrivacy,
    ModalBlackjackRules,
    ModalDuelsGame,
    ModalBattlesModes,
    ModalBattlesSelect,
    ModalBox,
    ModalAdminConfirm,
    ModalAdminUser,
    ModalAdminAffiliate,
    ModalAdminCrypto,
    ModalNotifications,
    ModalSocialComplete,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    ...mapActions(["modalsSetShow"]),
    modalsCloseButton(e) {
      if (
        e.target.className === "modals-holder" ||
        e.target.className === "holder-body"
      ) {
        this.modalsSetShow(null);
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  computed: {
    ...mapGetters(["modalsShow"]),
  },
};
</script>

<style scoped>
/* === Overlay === */
.modals .modals-overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color:rgb(0 0 0 / 85%);
  user-select: none;
  z-index: 101;
}

/* === Holder === */
.modals .modals-holder {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 102;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modals .modals-holder::-webkit-scrollbar {
  display: none;
}

/* === Modal Desktop === */
.body-modal {
  position: relative;
  border-radius: 15px;
  background: var(--background);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  
  width: 100%;
  margin: auto;
  overflow: hidden;
}

/* === Modal Bottom Sheet (Mobil) === */
.body-modal.bottom-sheet {
  width: 100%;
  max-width: 100%;
  border-radius: 20px 20px 0 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
}

/* === Close Button === */
.modals .body-modal button.button-close {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 15px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 5;
}
.modals .body-modal button.button-close .button-inner {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.3s ease;
}
.modals .body-modal button.button-close .button-inner svg {
  width: 35px;
  height: 35px;
  fill: #75adc2;
  transition: fill 0.3s ease;
}
 
.modals .body-modal button.button-close:hover .button-inner svg {
  fill: #ffffff;
}

/* === Animations === */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Desktop modal animation */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(50px);
  opacity: 0;
}

/* Bottom sheet animation */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
